export const ProgressBar = ({
  current,
  total
}: {
  current: number;
  total: number;
}) => {
  const progress = total > 0 ? ((current + 1) / total) * 100 : 0;
  return (
    <div className="h-1 w-full flex">
      <div
        className="bg-primary-500 transition-all duration-300 rounded-r"
        style={{ width: `${progress}%` }}
      />
      <div className="bg-primary-100 flex-grow" />
    </div>
  );
};
